/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RecentJamieMeeting
 */
export interface RecentJamieMeeting {
  /**
   *
   * @type {string}
   * @memberof RecentJamieMeeting
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof RecentJamieMeeting
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof RecentJamieMeeting
   */
  meetingDate?: OffsetDateTime | null;
}

/**
 * Check if a given object implements the RecentJamieMeeting interface.
 */
export function instanceOfRecentJamieMeeting(
  value: object,
): value is RecentJamieMeeting {
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  return true;
}

export function RecentJamieMeetingFromJSON(json: any): RecentJamieMeeting {
  return RecentJamieMeetingFromJSONTyped(json, false);
}

export function RecentJamieMeetingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RecentJamieMeeting {
  if (json == null) {
    return json;
  }
  return {
    jamieMeetingId: json["jamieMeetingId"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
  };
}

export function RecentJamieMeetingToJSON(json: any): RecentJamieMeeting {
  return RecentJamieMeetingToJSONTyped(json, false);
}

export function RecentJamieMeetingToJSONTyped(
  value?: RecentJamieMeeting | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jamieMeetingId: value["jamieMeetingId"],
    title: value["title"],
    meetingDate: value["meetingDate"],
  };
}
